module.exports = __webpack_public_path__ + "static/media/product-screens-bg.36b31db8.svg";